import React from "react";
import { useSelector } from "react-redux";
import TopFilter from "./topFilter";
import BtmFilter from "./btmFilter";
import styles from './index.module.scss';

function Filter() {

  const {
    searchLoading
  } = useSelector(state => state.searchReducer);

  if(searchLoading) return null;

  return (
    <>
      <div className={styles.filter}>
        <TopFilter />
        <BtmFilter />
      </div>
      <div className="clr"></div>
    </>
  )
}

export default Filter;